<template>
  <div id="app">
    <Navbar/>
    <router-view></router-view>
    <Footer/>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Index from './components/Index.vue'
import Footer from './components/Footer.vue'

// import axios from 'axios'

export default {
  name: 'app',
  components: {
    Index,
    Navbar,
    Footer
  }
}
</script>

<style>
#app {
    font-family: "Lantinghei SC","Open Sans",Arial,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",STHeiti,"WenQuanYi Micro Hei",SimSun,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
  background-color: #F7F9FA;
}
a {
  text-decoration:none;
}
body {
    min-width: 720px;
        margin: 0;
}
html,bodu{
    height: 100%;
}
</style>
